module.exports = __webpack_public_path__ + "img/justine_et_huguette.a487316f.jpeg";